import { store } from '@src/state/store';
import { cardsUpdated } from '@src/state/slices/slice_game';

export default () => (data: any) => {
  if (data.gameId === null || data.cards === null) return;
  store.dispatch(
    cardsUpdated({
      gameId: data.gameId,
      playerId: data.playerId,
      cards: data.cards,
    }),
  );
};
